import thumbnailImg from 'Static/thumbnails/screenshot--earth.png';

export default {
  slug: 'earth',
  title: 'The Earth',
  seriesNumber: '5',
  published: true,
  thumbnailImg,
  subject: 'Earth Science',
  graphicFileName: 'Image_Earth.png',
  graphicAlt:
    'App screenshot of The Earth depicting a cross section of rock and water',
  iconFileName: 'Icon_Earth.png',
  iconLargeFileName: 'Icon_Earth@2x.png',
  iconAlt: 'App icon for The Earth depictinga volcano',
  description:
    'Topics covered include weathering, erosion, deposition, geologic time, plate tectonics, plate boundaries, landforms, and conservation.',
  briefDescription: 'Learn about geology, conservation & more.',
  supportedLanguages: [
    'en',
    'af',
    'ar',
    'bg',
    'bn',
    'ca',
    'cs',
    'da',
    'de',
    'el',
    'es',
    'fa',
    'fi',
    'fl',
    'fr',
    'he',
    'hi',
    'hr',
    'ht',
    'hu',
    'id',
    'is',
    'it',
    'ja',
    'km',
    'ko',
    'ms',
    'nb',
    'nl',
    'pa',
    'pl',
    'pt',
    'ro',
    'ru',
    'sk',
    'sl',
    'sr',
    'sv',
    'ta',
    'th',
    'tl',
    'tr',
    'uk',
    'ur',
    'uz',
    'vi',
    'zh-Hans',
    'zh-Hant',
  ],
  scenes: [
    'Scene_Globe',
    'Scene_Globe_SliderOpen',
    'Scene_Main',
    'CloseUp_Cliff',
    'CloseUp_Shore',
    'CloseUp_Dune',
    'Special_Volcano',
    'Special_Volcano_SliderClosed',
    'CloseUp_Deforestation',
    'CloseUp_CleanEnergy',
    'Special_Earthquake',
    'Special_Earthquake_SliderOpen',
    'CloseUp_LandSlide',
    'CloseUp_TapARock',
    'CloseUp_River',
    'CloseUp_Glacier',
    'CloseUp_FrostWedge',
    'CloseUp_UnderwaterVolcano',
    'CloseUp_OceanHealth',
    'CloseUp_DivergentPlates',
    'CloseUp_Soil',
    'CloseUp_TreeRootWeathering',
  ],
  featuredPrintables: ['earth_weathering'],
  printables: ['concept_map', 'generating_questions'],
  topics: [
    'major_systems',
    'plate_tectonics',
    'human_impact',
    'weathering_erosion',
  ],
  appLinks: {
    appStoreLink:
      'https://apps.apple.com/us/app/the-earth-by-tinybop/id1001247878',
    googlePlayLink:
      'https://play.google.com/store/apps/details?id=com.tinybop.Earth',
  },
};
